import React from 'react';
import './side.css'
import Main from './spiderman'
import { getsitedata, logout } from "./../action/user";

function Side() {
  const onlogout = async () => {
    var test = await logout();
    window.location = "/";
  }

  return (
    <div className='row'>
      <div className='col-md-2'>
        <div className="sidebar">
          <a className="active" href='/myprofile'>My Profile</a>
          <a href='/showCard'>Guys I've Viewed</a>
          <a href='/anotherviewed'>Guys Who Viewed Me</a>
          <a href='/saved'>Favorites</a>
          <a href='/membership'>Membership Details</a>
          <a onClick={onlogout}>Log Out</a>
        </div>
      </div>
      <div className='col-md-10'>
        <div className="contents">
          <Main />
        </div>
      </div>
    </div>
  );
}
export default Side;